const systemRequirementsUrl = '/system-requirements';

export default systemRequirementsUrl;
